import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const DnrScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.015 4.34375V4.34999C19.9217 4.21776 21.1317 8.08356 21.1317 8.08356C22.0897 9.38588 21.975 14.9095 21.1317 16.1757C21.1317 16.1757 19.3117 20.7101 11.015 20.7375V20.75H6.65649L6.65649 6.77874L4.34375 5.87809V4.34375L11.015 4.34375ZM11.015 18.1516L11.015 6.90972C15.8813 6.44942 17.105 9.38713 17.105 9.38713C17.8731 11.4004 17.8731 13.626 17.105 15.6393C17.105 15.6393 16.4302 18.7666 11.015 18.1516Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Dnr'
);
export default DnrScaleMediumAppearanceDefault;
